import React, { useContext, useState } from "react";
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { HiTrendingUp } from "react-icons/hi";
import { HiOutlineNewspaper } from "react-icons/hi";
import { LuMapPin } from "react-icons/lu";
import { FaDonate } from "react-icons/fa";
import { LuTrendingUp } from "react-icons/lu";
import { MdAddCircleOutline } from "react-icons/md";
import { AuthContext } from "../context/UserContext";
import Logo from "../assets/Logo.png";
import { useNavigate, useLocation } from "react-router";
import Switcher from "./Switcher";
import { RiSettings4Line } from "react-icons/ri";

const Navbar = () => {
  const { userAuth, setUserAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const navItems = [
    { text: "News", link: "/home", icon: <HiOutlineNewspaper size={20} /> },
    { text: "Featured", link: "/featured", icon: <LuTrendingUp size={20} /> },
    { text: "Add", link: "/addpost", icon: <MdAddCircleOutline size={30} /> },
    { text: "Maps", link: "/maps", icon: <LuMapPin size={20} /> },
    { text: "Settings", link: "/profile", icon: <RiSettings4Line size={20} /> },
  ];

  return (
    <div className="z-[999999] fixed bottom-0 w-full dark:bg-[#161b22] bg-white border-t-2 border-[#3c3c3c] text-[#161b22] dark:text-[#FAF7F0]">
      <ul className="flex justify-between w-full h-16 px-4 2xl:px-16">
        {navItems.map((item, index) => (
          <a
            href={item.link}
            key={index}
            className={`hover:text-[#dedede] hover:bg-[#3B7BD3] active:bg-[#3B7BD3] ${
              location.pathname === item.link
                ? "bg-[#3B7BD3] text-white"
                : ""
            }`}
          >
            <li className="w-full flex flex-col items-center justify-center p-3 cursor-pointer text-sm text-center">
              {item.icon}
              <span className="hidden md:flex font-semibold">{item.text}</span>
            </li>
          </a>
        ))}
      </ul>
    </div>
  );
};

export default Navbar;
